import React, {useEffect} from "react";
import {Outlet} from "react-router-dom";
import './index.scss';
import '../../assets/font/iconfont.css';
import {useTranslation} from "react-i18next";
import {Provider} from 'react-redux';
import {store} from '../../store';

const publicUrl = process.env.PUBLIC_URL;

export const AssistantNewLayout = () => {
    const {t} = useTranslation();
    useEffect(() => {
        document.title = t('assistant_new.name');
        const faviconLink = document.querySelector("link[rel='icon']");
        const appleFaviconLink = document.querySelector("link[rel='apple-touch-icon']");
        //@ts-ignore
        if (faviconLink) faviconLink.href = publicUrl + '/favicon-grey.ico';
        //@ts-ignore
        if (appleFaviconLink) appleFaviconLink.href = publicUrl + '/favicon-grey.ico';
    }, []);
    return <Provider store={store}>
        <div className={'enaea_layout'} data-theme={'grey'}>
            <Outlet/>
        </div>
    </Provider>;
};

